import { boot } from 'quasar/wrappers'
import mime from 'mime-types'

export default boot(({ app }) => {
	app.config.globalProperties.$mime = mime
})
